module.exports = __webpack_public_path__ + "img/adobestock-316641157@1x.c241f178.png";